import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonFunctions } from '@shared/common-functions';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ReattemptBookingModalComponent } from '../reattempt-booking-modal/reattempt-booking-modal.component';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { USER_CONVERTED_TO_GROUP_OPERATOR_MSG } from '@shared/constant/shared.constant';

@Component({
  selector: 'app-user-convert-to-group-operator-modal',
  templateUrl: './user-convert-to-group-operator-modal.component.html',
  styleUrls: ['./user-convert-to-group-operator-modal.component.scss']
})
export class UserConvertToGroupOperatorModalComponent implements OnInit {
  convertUserToGroupOperatorForm: FormGroup;
  userId: string = '';

  constructor(
    private readonly fb: FormBuilder,
    public readonly ref: DynamicDialogRef,
    public readonly dialogControlService: DialogControlService,
    private readonly config: DynamicDialogConfig,
  ) { }

  ngOnInit() {
    this.userId = this.config.data?.userId || '';
    this.convertUserToGroupOperatorForm = this.fb.group({
      groupName: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(50)]],
    });
  }

  preventFirstSpace(event: KeyboardEvent) {
    CommonFunctions.preventFirstSpaces(event);
  }

  onSubmit() {
    if (this.convertUserToGroupOperatorForm.invalid) {
      return;
    }
    
    this.dialogControlService.openDialog(ReattemptBookingModalComponent, {
      width: '25%',
      data: {
        userId: this.userId,
        email: null,
        groupName: this.convertUserToGroupOperatorForm.value.groupName,
        isPreferredPaymentSelected: false,
        bodyText: USER_CONVERTED_TO_GROUP_OPERATOR_MSG,
        headerText: 'Confirmation',
        isFunctionAttempted: 1
      },
    });
    this.close();
    
  }

  close() {
    this.ref.close();
  }
}
